import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
import { Modal } from '@veneer/core';

const { color, layout, typography } = primitives;

export const Container = styled.div``;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${typography.size5};
`;

export const StyledTitle = styled.p`
  font-weight: ${typography.weight4};
  font-size: ${typography.size5};
  line-height: ${typography.lineHeight5};
  color: ${color.gray12};
`;

export const StyledHelpLink = styled.button`
  font-weight: ${typography.weight3};
  font-size: ${typography.size3};
  line-height: ${typography.lineHeight3};
  text-decoration-line: underline;
  color: ${color.electricBlue7};
  cursor: pointer;
  transition: color 0.2s ease;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;

  &:hover {
    color: ${color.electricBlue8};
  }

  &:focus {
    outline: 2px solid ${color.electricBlue7};
    outline-offset: 2px;
  }

  @media (max-width: ${layout.breakpoint1}px) {
    display: none;
  }
`;

export const CardList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  align-items: stretch;
  width: 100%;
  margin-bottom: 50px;

  @media (max-width: ${layout.breakpoint2}px) {
    grid-template-columns: repeat(2, 1fr);
  }
  /* Mobile: single column */
  @media (max-width: ${layout.breakpoint1}px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledModal = styled(Modal)`
  width: calc(100% - 24px - 24px) !important;
  max-height: calc(100% - 24px);
  overflow-y: auto !important;
  @media (min-width: ${layout.breakpoint1}px) {
    max-width: 856px !important;
  }
`;
